import {useListItemTransactionState} from "../../hooks/useListItemTransactionState";

export const useListItemTransactionToast = () => {
    const {state, clear} = useListItemTransactionState();
    return {
        breakOutEarly: !state,
        show: !!state,
        onClose: clear,
        operation: state?.operation,
        name: state?.name ?? 'Favorites',
        path: state?.path ?? '/WishList/WishLists'
    };
}